export default __webpack_public_path__ + "static/media/il_proceso_sura.5b0b2258.svg";